import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    fetchEmpresasBegin: null,
    fetchEmpresasSuccess: ['empresas'],
    fetchEmpresasFailure: ['error'],
    uploadPfxSuccess: ['status'],
    uploadPfxFailure: ['status'],
})

export const fetchEmpresas = () => dispatch => {
    dispatch(Creators.fetchEmpresasBegin())
    return getHTTPClient()({
        method: 'GET',
        url: '/empresas/with-certificates',
    })
    .then(response => dispatch(Creators.fetchEmpresasSuccess(response.data.empresas)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
                showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.fetchEmpresasFailure(true))
    })
}

export const uploadPFX = (form, config) => dispatch => {
    let data = new FormData()
    data.append('pfx', form.pfx, form.pfx.name)
    data.append('pwd', form.senha)
    data.append('type', config.type)
    data.append('index', config.index)

    return getHTTPClient()({
        method: 'POST',
        url: `/empresas/pfx/${config.empresa}/${form.cnpj.replace(/\D/g, '')}`,
        data: data
    }, { 
        headers: { 'content-type': 'multipart/form-data' } 
    }).then(
        response => {
            showNotification('Configuração realizada com sucesso.', 'alert-success', 3000)
            return dispatch(Creators.uploadPfxSuccess(true))
        },
        error => {
            checkStatusCode(error.response.status)
            if (error.response) {
                showNotification(error.response.data.message, 'alert-danger')
            } else if (error.request) {
                if (process.env.NODE_ENV === 'development' )
                    console.log(error.request)
                    showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
            } else {
                showNotification(error.message, 'alert-danger')
            }
            return dispatch(Creators.uploadPfxFailure(false))
        }
    )
} 

export const downloadPFX = (empresa, cnpj, filename) => dispatch => {
    return getHTTPClient()({
        method: 'GET',
        url: `/empresas/pfx/${empresa}/${cnpj}`,
        responseType: 'blob'
    }).then(
        response => {
            const url = URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
        },
        error => {
            checkStatusCode(error.response.status)
            if (error.response) {
                showNotification(error.response.data.message, 'alert-danger')
            } else if (error.request) {
                if (process.env.NODE_ENV === 'development' )
                    console.log(error.request)
                    showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
            } else {
                showNotification(error.message, 'alert-danger')
            }               
        }
    )
}